export const FETCH_TOP_EVENTS_REQUEST = 'FETCH_TOP_EVENTS_REQUEST';
export const FETCH_TOP_EVENTS_SUCCESS = 'FETCH_TOP_EVENTS_SUCCESS';
export const FETCH_TOP_EVENTS_ERROR   = 'FETCH_TOP_EVENTS_ERROR';

export const FETCH_APP_SIGNUP_GRAPH_REQUEST = 'FETCH_APP_SIGNUP_GRAPH_REQUEST';
export const FETCH_APP_SIGNUP_GRAPH_SUCCESS = 'FETCH_APP_SIGNUP_GRAPH_SUCCESS';
export const FETCH_APP_SIGNUP_GRAPH_ERROR   = 'FETCH_APP_SIGNUP_GRAPH_ERROR';